import { useState, useEffect, useContext } from "react"
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { useAlert } from "react-alert";


function AddCredits(props) {
    const [credits, setCredits] = useState("")
    const alert = useAlert()
    const [credNo, setCredNo] = useState(0)
    const [credNo1, setCredNo1] = useState(null)
    const [error, setError] = useState(false)
    const [display, setDisplay] = useState(false)
    const [wallet, setWallet] = useState(props.wallet)
    const [link, setLink] = useState("")
    useEffect(() => {

        const tokenString = sessionStorage.getItem("usertoken");

        let v2 = tokenString.replace(
            /["]+/g,
            ""
        );

        axios.get(`${APIURL}/api/v1/staff/master-credit-system/?${TZ}`, {
            headers: { Authorization: "Token " + v2 },
        })
            .then((res) => {
                if (res.data.status === "success") {
                    const filteredData = res.data.credits.filter(item => {
                        return item.channel_type === props.type
                    })
                    console.log(filteredData, "filteredData")
                    setCredits(filteredData[0])
                }
                else {

                }
            })
            .catch((err) => {

            })

    }, [props.type])
    useEffect(() => {
        if (credNo <= 0 || !credNo) {
            setError(true)
        }
        else {
            setError(false)
        }
    }, [credNo])


// (wallet < credits.min_limit)
    const addCredits1 = () => {

        if (!error) {

            const tokenString = sessionStorage.getItem("usertoken");

            let v2 = tokenString.replace(
                /["]+/g,
                ""
            ); /* REGEX To remove double quotes from tokenstring */

            const dataToSend = {

                "hospital_id": Number(props.id),
                "credits":
                    [{
                        "purchased_credit": credNo,
                        "credit": credits.id
                    }
                    ]

            }

            axios
                .post(`${APIURL}/api/v1/service-provider/clinic-top-up/`, dataToSend, {
                    headers: { Authorization: "Token " + v2 },
                })
                .then((res) => {
                    if (res.data.status === "success") {

                        setLink(res.data.license_bill_id)
                        setDisplay(true)

                    } else {
                        alert.error(res.data.message)

                    }
                })
                .catch((err) => {
                    alert.error("Please fill all mandatory fields!")

                });
        }
    }

    return (<>
        <div className="" >
            <div className="title-of-tasks" style={{}}><h5>Add Credits</h5></div>
            <div className="" style={{ paddingLeft: "2%" }}>
                <div className="" style={{ paddingTop: "3%", paddingBottom: "1%", backgroundColor: "aliceblue" }}>
                    <div className="row" style={{ margin: "auto", fontSize: "14px" }}>
                        <p className="text-left col-4 ">1 Credit= <span className='text-info span-size'>Rs{credits.price}/-</span></p>
                        <p className="text-left col-4 ">Min credits= <span className='text-info span-size'>{props.wallet < 0 ? credits.min_limit + (0 - props.wallet) : credits.min_limit}</span></p>
                        <p className="text-left col-4 ">wallet= <span className='text-info span-size'>{wallet}</span></p>
                    </div>
                </div>
                <br />
                <div className='row'>
                    <span className='span-size' style={{ textAlign: "left", marginLeft: "5%" }}><h6>Choose credit</h6></span>
                    <div className='flex-row invoice-radio col-7' >

                        <input type='radio' className='hideme' checked={credNo === 10} id={10} value={10} onChange={() => { setCredNo1(""); setCredNo(10); setWallet(props.wallet + 10) }} />
                        <label htmlFor={10} className='invoice-label'>
                            10
                        </label>
                        &nbsp;&nbsp;
                        <input type='radio' className='hideme' checked={credNo === 20} id={20} value={20} onChange={() => { setCredNo1(""); setCredNo(20); setWallet(props.wallet + 20) }} />
                        <label htmlFor={20} className='invoice-label'>
                            20
                        </label>
                        &nbsp;&nbsp;
                        <input type='radio' className='hideme' checked={credNo === 30} id={30} value={30} onChange={() => { setCredNo1(""); setCredNo(30); setWallet(props.wallet + 30) }} />
                        <label htmlFor={30} className='invoice-label'>
                            30
                        </label>

                        &nbsp;&nbsp;

                    </div>
                    <h5 className="col-2">OR</h5>
                    <input placeholder="Enter" style={{ padding: "0.2%" }} type="number" className='invoice-label col-2' value={credNo1} onChange={(e) => { setCredNo(e.target.value === "" ? null : Number(e.target.value)); setCredNo1(e.target.value === "" ? null : Number(e.target.value)); setWallet(props.wallet + Number(e.target.value)) }} />


                </div><br />

                <span className='span-size ' style={{ background: "aliceblue" }}>Total: Rs{credits.price * credNo}{credits.price * credNo !== 0 && " +18% GST"}{credNo > 100 ? "+2% discount" : credNo > 50 ? "+1% discount" : ""}</span>


                {!display && <div className="form-heading title-of-tasks" style={{}}>
                    <button style={{ width: "20%" }} onClick={() => { addCredits1() }} className="clinic_button">Add</button>
                    {error && <><br /> <span className='span-size' style={{ color: "red" }}>Please add at least 1 credit</span></>}
                </div>}

                {display && <div className="form-heading title-of-tasks det-div" style={{ padding: "1%" }}>
                    <span className='span-size' style={{ color: "blue" }}>Would you like to send a payment link to the clinic?</span>
                    <button style={{ width: "20%", backgroundColor: "#1b5284" }}
                        onClick={() => {
                            const tokenString = sessionStorage.getItem("usertoken");

                            let v2 = tokenString.replace(
                                /["]+/g,
                                ""
                            ); /* REGEX To remove double quotes from tokenstring */

                            const dataToSend = {

                                license_bill_id: link

                            }

                            axios
                                .post(`${APIURL}/api/v1/payment/razorpay-link/`, dataToSend, {
                                    headers: { Authorization: "Token " + v2 },
                                })
                                .then((res) => {
                                    if (res.data.status === "success") {

                                        alert.success(res.data.message)
                                        props.onSuccess()

                                    } else {
                                        alert.error(res.data.message)

                                    }
                                })
                                .catch((err) => {


                                });
                        }} className="clinic_button">Send</button>

                </div>}

            </div>


        </div>

    </>
    )
}
export default AddCredits